import React, { useEffect, useState } from "react";
import axios from "../Components/Axios/Axios";
import { Container, Button, Card, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
// import CKEditor from "ckeditor4-react-advanced";
import Loader from "../Components/Spinner/Spinner";
import requests from "../Components/Requests/Requests";
// import {CKEditor} from "ckeditor4-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

function AddBlogs() {
  const [originalUID, setOriginalUID] = useState("");
  const [duplicateUID, setDuplicateUID] = useState("");
  const [loading, setloading] = useState(false);

  const mergeUID = async () => {
    if (window.navigator.onLine) {
      if (duplicateUID == "") {
        toast.warn("Duplicate UID cannot be null", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (originalUID == "") {
        toast.warn("Original UID cannot be null", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }

      const formData = new FormData();
      formData.append("duplicate", duplicateUID);
      formData.append("original", originalUID);

      const data = {
        duplicate: duplicateUID,
        original: originalUID,
      };
      try {
        console.log(requests.mergeUID, "mergeuid");
        const responce = await axios.post(requests.mergeUID, data);
        setloading(true);
        if (responce?.data?.Success === 1) {
          toast.success("UID Merged Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setloading(false);
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        } else {
          toast.warn("Problem with merge API", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        console.error(err);
        //  console.error(err);
        toast.error("Merge failed. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setloading(false);
      }
    } else {
      toast.error("No internet connection", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Card>
          <Card.Header className="heading">Merge UID</Card.Header>
          <Card.Body>
            <Row>
              <Col className="main">
                <Form.Group className="mb-3">
                  <Form.Label>Original UID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Original UID"
                    onChange={(e) => setOriginalUID(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className="main">
                <Form.Group className="mb-3">
                  <Form.Label>Duplicate UID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Duplicate UID"
                    onChange={(e) => setDuplicateUID(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="footer">
            {loading == true ? (
              <Loader margin={0} />
            ) : (
              <Button
                className="submit-btn"
                onClick={() => mergeUID()}
                variant="primary"
              >
                Merge UID
              </Button>
            )}
          </Card.Footer>
        </Card>
      </Container>
    </div>
  );
}

export default AddBlogs;
